import { UserRole } from 'shared';

export let NavMenuItems: any[] = [
    {
        icon: 'log-in-outline',
        label: 'common.login',
        path: 'login',
        isAuthVisible: false,
    },
    {
        icon: 'person-circle-outline',
        label: 'navigation.profile',
        path: 'profile',
        visibleFor: [UserRole.ProviderAdmin, UserRole.AreaManager],
    },
    {
        icon: 'log-out-outline',
        label: 'common.logout',
        path: 'logout',
        isAuthVisible: true,
    },
];
